import { createFileRoute } from '@tanstack/react-router';

import { FormItemView } from '#/features/community-hub/components/block-viewers/form-item-view';

export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/form/$itemSlug')({
  component: FormContentRoute,
});

function FormContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <FormItemView key={itemSlug} itemSlug={itemSlug} />;
}
